import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import LegalLinks from '../components/LegalLinks';

export default function UnderConstruction() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f4f6f7',
      }}
    >
      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ p: 6, textAlign: 'center', borderRadius: 2 }}>
          <ConstructionIcon sx={{ fontSize: 80, color: '#f57c00', mb: 3 }} />
          <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
            Under Construction
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ mt: 2 }}>
            We're working hard to bring you something amazing.
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
            Please check back soon!
          </Typography>
          <Box sx={{ mt: 3, color: 'text.secondary' }}>
            <LegalLinks centered />
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
